import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { SmallButton } from '@/components/Button';
import { SetsModal } from '@/components/SetsModal';
import { styles } from './styles';

export const NoSets = () => {
  const [isSetsModalVisible, setIsSetsModalVisible] = useState(false);

  const changeSetsModalVisibility = useCallback((value) => {
    if (!value) {
      return setIsSetsModalVisible((prevState) => !prevState);
    }
    setIsSetsModalVisible(value);
  }, []);

  const handleShowModalPress = useCallback(() => {
    changeSetsModalVisibility(true);
  }, []);

  return (
    <>
      <View style={styles.noSetsView}>
        <Text style={styles.noSetsTitleText}>
          Noch keine Übungssets erstellt
        </Text>
        <SmallButton
          icon="plusCircle"
          label="Neues Set erstellen"
          onPress={handleShowModalPress}
        />
      </View>
      <SetsModal
        isSetsModalVisible={isSetsModalVisible}
        changeSetsModalVisibility={changeSetsModalVisibility}
      />
    </>
  );
};
